import {Component, DestroyRef, inject, OnInit, ViewChild} from '@angular/core';
import { throwExpression} from '../../../shared/utils';
import { FormHelperService } from 'src/app/shared/services/form-helper.service';
import { models } from 'src/app/shared/models';
import { VTableComponent } from '@vasio-nl/valow';
import { CustomDistanceComponent } from './custom-distance-column/custom-distance-column.component';
import { CustomSpaceForSiblingsColumnComponent } from './custom-space-for-siblings-column/custom-space-for-siblings-column.component';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-nearby-locations',
  templateUrl: './nearby-locations.component.html',
  styleUrls: ['./nearby-locations.component.scss'],
})
export class NearbyLocationsComponent implements OnInit {
  @ViewChild('table', {static: true}) table: VTableComponent<any, any, any> | null = null;
  
  private router = inject(Router)
  private activatedRoute = inject(ActivatedRoute)
  private destroyRef = inject(DestroyRef)

  public formHelperService = inject(FormHelperService)
  public models = models;
  public tableFields : any[] = []
  
  public filters : any

  ngOnInit(): void 
  {
    const newcomerId = this.activatedRoute.snapshot.params['newcomerId']

    if ( ! newcomerId)
    {
      throwExpression('Missing newcomer id')
    }

    this.filters = {isNewcomer: true, search: '', orderByDistanceFromNewcomerId: newcomerId}

    this.tableFields = this.formHelperService.getTableFields('Location', [
      { field: 'capacityDisplay', flex: '0.5' },
      { field: 'cityAreaName', flex: '0.5' },
      { field: 'name', flex: '2' },
      { field: 'newcomerSpaceForSiblings', customComponent: CustomSpaceForSiblingsColumnComponent, flex: '1' },
      { field: 'distanceToNewcomer', argument: { newcomerId }, customComponent: CustomDistanceComponent, flex: '0.5' }
    ])

    if ( ! this.table)
    {
      throwExpression('Table did not initialize')
    }
  }

  openLocation(location: any) {
    this.router.navigate(['/', 'locatie', location.id]).then();
  }
}


